import { render, staticRenderFns } from "./leftRow.vue?vue&type=template&id=90ca7ab2&scoped=true"
import script from "./leftRow.vue?vue&type=script&lang=js"
export * from "./leftRow.vue?vue&type=script&lang=js"
import style0 from "./leftRow.vue?vue&type=style&index=0&id=90ca7ab2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90ca7ab2",
  null
  
)

export default component.exports